<template>
  <div class="device-category-selector" data-cy="device-category-select">
    <span class="device-category-selector__device-type-text text-one-line">{{ t("device") }}:</span>
    <ButtonGroup v-model="selectedDeviceCategory" :options="options" />
  </div>
</template>

<script lang="ts" setup>
import { ButtonGroup } from "@bebit/atomic";
import { DeviceCategory } from "@bebit/types";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import type { Icon } from "@bebit/atomic";

const { t } = useI18n();

const props = defineProps<{
  modelValue?: DeviceCategory;
}>();

const emits = defineEmits<{
  (event: "update:modelValue", selectedDeviceCategory: DeviceCategory): void;
}>();

interface Option {
  text: string;
  disabled: boolean;
  icon: Icon;
}

const options: Option[] = [
  {
    text: "PC",
    disabled: false,
    icon: "pc",
  },
  {
    text: "SP",
    disabled: false,
    icon: "sp",
  },
];

const selectedDeviceCategory = computed({
  get() {
    return props.modelValue === DeviceCategory.PC ? 0 : 1;
  },

  set(deviceCategoryIndex: number) {
    const deviceCategory = deviceCategoryIndex === 0 ? DeviceCategory.PC : DeviceCategory.SP;
    emits("update:modelValue", deviceCategory);
  },
});
</script>

<style lang="scss" scoped>
.device-category-selector {
  align-items: center;
  display: flex;
  margin-right: 24px;
}
.device-category-selector__device-type-text {
  color: $colorGray1000;
  font-size: 13px;
  font-weight: 400;
  margin-right: 8px;
}
</style>

<i18n lang="yaml">
en:
  device: Device
ja:
  device: デバイス
zh-hant:
  device: 裝置
zh-hans:
  device: 设备
</i18n>
